export const renderPercent = (amount: number, short?: boolean) => {
    const digits = short ? (amount % 1 === 0 ? 0 : 2) : 2;
    const formatter = new Intl.NumberFormat("de-DE", {
        style: "percent",
        minimumFractionDigits: digits,
    });

    return formatter.format(amount);
};
